import styled from 'styled-components'

export const StyledNewsFiltersPanel = styled.div`
  .filtersContainer {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
  }
`
